// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.singlefamilyenterprise.properties.RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface CustomerIdParams {
  customerId: string;
  listingAlias: ListingAlias;
}

export const RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Path =
  '/api/web/v1/users/singleFamilyEnterprise/properties/customerId';

/**
 * Edit single family enterprise contract customerId for a listing
 */
export const RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId = (
  getParams: CustomerIdParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CustomerIdParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserSingleFamilyEnterprisePropertyWebApiHandler_customerId_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
